const OLDEST_BIRTH_YEAR = 1901;

export const birthYearOptions = (today: Date = new Date()): number[] => {
  const thisYear = today.getFullYear();
  const years: number[] = [];

  for (let year = thisYear; year >= OLDEST_BIRTH_YEAR; year--) {
    years.push(year);
  }

  return years;
};
